export default function migrateModifier(modifier) {
  // Init `applyToExtraAttacks` property on any `increaseWeaponAttacks` effects.
  if (modifier.effect.type === "increaseWeaponAttacks") {
    modifier.effect.data.applyToExtraAttacks = false
  }

  return modifier
}
